class ZodiacWheel {
  constructor() {
    this.wheel = document.querySelector('.zodiac-wheel__circle');
    this.signs = document.querySelectorAll('.zodiac-wheel__sign');
    this.gridItems = document.querySelectorAll('.zodiac-wheel__grid-item');
    this.radius = 0;
    
    if (this.wheel) {
      this.init();
    }
  }

  init() {
    this.calculatePositions();
    this.setupHoverEffects();
    this.setupScrollAnimation();
    window.addEventListener('resize', () => this.calculatePositions());
  }

  calculatePositions() {
    if (!this.wheel) return;
    
    // Get ellipse dimensions
    const width = this.wheel.offsetWidth;
    const height = this.wheel.offsetHeight;
    const centerX = width / 1.7;
    const centerY = height / 1.6;
    
    // Detect sign size from DOM (fallback to defaults)
    const sampleSign = this.signs[0];
    const signSizeActual = sampleSign ? sampleSign.offsetWidth / 2 : 50; // half-size
    const defaultSignSize = window.innerWidth <= 749 ? 30 : 50;
    const signSize = isNaN(signSizeActual) || signSizeActual === 0 ? defaultSignSize : signSizeActual;
    
    // Padding from edge
    const padding = window.innerWidth <= 749 ? 5 : 10;
    
    // Ellipse radii (separate X/Y) - leave space for sign + padding
    let radiusX = width / 2.1 - signSize - padding;
    let radiusY = height / 2.1 - signSize - padding;
    
    // Minimum bounds safeguard
    const minRadius = Math.min(width, height) * 0.35;
    if (radiusX < minRadius) radiusX = minRadius;
    if (radiusY < minRadius) radiusY = minRadius;
    
    this.signs.forEach((sign, index) => {
      const angle = index * 30; // 360 / 12 = 30 degrees per sign
      const radians = (angle - 90) * (Math.PI / 180); // start at top
      
      const x = centerX + radiusX * Math.cos(radians);
      const y = centerY + radiusY * Math.sin(radians);
      
      sign.style.left = `${x}px`;
      sign.style.top = `${y}px`;
      sign.style.transform = `translate(-50%, -50%)`;
    });
  }

  setupHoverEffects() {
    this.signs.forEach((sign) => {
      sign.addEventListener('mouseenter', () => {
        const signName = sign.getAttribute('data-sign');
        this.highlightGridItem(signName);
      });
      
      sign.addEventListener('mouseleave', () => {
        this.removeHighlight();
      });
    });
  }

  highlightGridItem(signName) {
    this.gridItems.forEach((item) => {
      if (item.getAttribute('data-sign') === signName) {
        item.style.transform = 'scale(1.05)';
        item.style.transition = 'transform 0.3s ease';
      }
    });
  }

  removeHighlight() {
    this.gridItems.forEach((item) => {
      item.style.transform = '';
    });
  }

  setupScrollAnimation() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry, index) => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              entry.target.classList.add('visible');
            }, index * 100);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );

    this.gridItems.forEach((item) => {
      observer.observe(item);
    });
  }
}

// Initialize on page load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new ZodiacWheel());
} else {
  new ZodiacWheel();
}

// Reinitialize in theme editor
if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => new ZodiacWheel());
}

